enum ProviderExperienceTypes {
  PROVIDER_ACCEPTED = 1,
  SCA_NEEDED = 3
}

export default ProviderExperienceTypes;
